import React from "react";
import ReactDOM from "react-dom";
import HexModal from "../../../../app/components/modals/HexModal";
import { showErrorMessage } from "../../../commons/show-error-message";
import RecurrentSubsidyModal from "../../components/RecurrentSubsidyModal";
import { logError, addContextLog } from "../../../../infrastructure/log";
import { translate } from "../../../../infrastructure/translate/localization";

function renderRecurrentSubsidyModal({ message, model, isRecurrent, alertId }) {
  ReactDOM.render(
    <HexModal>
      <RecurrentSubsidyModal
        message={message}
        isRecurrent={isRecurrent}
        model={model}
        alertId={alertId}
      />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayRecurrentSubsidy({
  message,
  model,
  isRecurrent,
  alertId,
}) {
  try {
    renderRecurrentSubsidyModal({
      message,
      model,
      isRecurrent,
      alertId,
    });
    addContextLog("info", "displayRecurrentSubsidy", "display-screen", {
      modelId: model.id,
    });
  } catch (e) {
    logError(e, `Error to displayRecurrentSubsidy in ${model}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
